import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { take } from 'rxjs/operators';
import { NoticiasService } from 'src/app/services/noticias.service';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { FormsModule } from '@angular/forms';
import { FooterComponent } from '../../components/footer/footer.component';
import { AppDatePipe } from '../../pipes/app-date.pipe';

@Component({
    selector: 'app-noticias-detalhes',
    templateUrl: './noticias-detalhes.component.html',
    styleUrls: ['./noticias-detalhes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, BreadcrumbComponent, RouterLink, FormsModule, FooterComponent, AppDatePipe]
})
export class NoticiasDetalhesComponent implements OnInit {

  private idEmpresaLogada: string;
  public idNoticia: string;
  public noticia: any = null;
  public noticias: any = null;
  public inputBusca: string = '';

  constructor(
    public rotaAtiva: ActivatedRoute,
    public router: Router,
    private readonly service: NoticiasService
    ) { }

  ngOnInit(): void {

    window.scrollTo(0, 0);
    this.idEmpresaLogada = localStorage.idEmpresaLogada;

    this.rotaAtiva.queryParams.subscribe((data: any) => {

      this.idNoticia = data.idNoticia;
      this.consultaNoticia(this.idNoticia);
      this.get3Noticias();

    });

  }

  consultaNoticia(idNoticia: string) {
    this.service.getNoticia(idNoticia).pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.noticia = response.response;
        document.querySelector<HTMLElement>('#conteudoNoticia').innerHTML = response.response.descConteudoNoticia;
      },
      error: (erro: any) => {
        this.noticia = false;
        console.error(erro);
      }
    });
  }

  get3Noticias() {
    this.service.getAllNoticias(this.idEmpresaLogada, '', '', '', '')
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.noticias = response.response.data.slice(0, 3);
      },
      error: (erro: any) => {
        this.noticias = false;
        console.error(erro);
      }
    });
  }

  buscaNoticias() {
    sessionStorage.noticiaInputBuscaFiltro = this.inputBusca;

    this.router.navigate(["noticias"]);
  }

  detalharNoticias(idNoticia: number) {
    this.router.navigate(["noticias-detalhes"], {queryParams: { idNoticia: idNoticia }});
    window.scroll(0, 0);
  }

  voltarPaginaNoticias(filtro: string) {

    this.router.navigate(['noticias']);

    setTimeout(function() {
      if (filtro === 'reajuste') {
        document.querySelector<HTMLButtonElement>('#botaoReajuste')?.click();
      }
      if (filtro === 'migracao') {
        document.querySelector<HTMLButtonElement>('#botaoMigracao')?.click();
      }
      if (filtro === 'data') {
        document.querySelector<HTMLButtonElement>('#botaoData')?.click();
      }
    }, 800);

  }

}
